import { useCallback, useSyncExternalStore } from 'react';
const isCallable = (t) => typeof t === 'function';
export const configHook = (config) => (key) => {
    const value = useSyncExternalStore(onChange => config.subscribe(key, onChange), () => config.get(key));
    const handleSetValue = useCallback((input, persist) => {
        // updating the value will trigger the subscriber above
        config.set({
            key,
            value: isCallable(input)
                ? input(config.get(key))
                : input,
            persist,
        });
    }, [key]);
    return [value, handleSetValue];
};
//# sourceMappingURL=configHook.js.map